<template>
    <simple-layout>
        <basic-card>
            <template slot="header">
                Scheduled jobs
            </template>
            <data-table
                    :configuration="scheduledJobTableConfig"
                    :data="jobSchedules"
                    @add="handleAdd"
                    @delete="handleDelete"
                    @focusedChanged="handleFocusedChanged"
                    component-id="scheduled-jobs-list"
            >
                <scheduled-job-card :job-schedule="focusedJob" v-if="focusedJob != null" @save="handleSave"/>
            </data-table>
        </basic-card>
    </simple-layout>
</template>

<script>
    import SimpleLayout from "../components/layout/SimpleLayout";
    import BasicCard from "../components/layout/BasicCard";
    import Toolbox from "../components/toolbox/Toolbox";
    import ToolboxButton from "../components/toolbox/ToolboxButton";
    import DataTable from "../components/table/DataTable";
    import ScheduledJobCard from "../cards/ScheduledJobCard";
    import {mapGetters} from "vuex";

    export default {
        name: "ProcessingScheduledJobsView",
        components: {ScheduledJobCard, DataTable, ToolboxButton, Toolbox, BasicCard, SimpleLayout},
        data:
            function () {
                return {
                    focusedJob: null,
                    scheduledJobTableConfig: {
                        objectName: "Job schedules",
                        enableAdd: true,
                        allowEdit: true,
                        columns: [
                            {
                                caption: "Id",
                                datum: d => d.id.substr(0, 5)
                            },
                            {
                                caption: "Job",
                                datum: d => this.importDefinitions.find(def => def.id == d.definitionId).displayName
                            },
                            {
                                caption: "Active",
                                datum: d => d.active ? this.$t("yes") : this.$t("no")
                            },
                            {
                                caption: "Schedule",
                                datum: d => {
                                    if(d.type == 'INTERVAL') {
                                        let hours = d.intervalMinutes / 60;
                                        if(hours > 1) {
                                            return `Every ${hours.toFixed(0)}h ${d.intervalMinutes % 60}m`
                                        }
                                        else {
                                            return `Every ${d.intervalMinutes} minutes`
                                        }
                                    }
                                    if(d.type == 'DAILY') {
                                        let days = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"]
                                        let time = d.time.substring(0, 5);
                                        if(d.days.length == 7) return `Daily at ${time}`
                                        return `Every ${d.days.map(day => days[day - 1]).join(", ")} at ${time}`
                                    }
                                }
                            },
                            {
                                caption: "Last run time",
                                datum: d => new Date(d.lastRunTime).toLocaleString()
                            }
                        ],
                        actions: [
                            {
                                icon: 'trash',
                                name: 'delete',
                                tooltip: 'Delete scheduled job',
                                accessLambda: (entry) => {
                                    return true;
                                }
                            },
                        ]

                    }
                }
            },
        computed: {
            ... mapGetters({
                jobSchedules: "jobSchedules/jobSchedules",
                importDefinitions: "importDefinitions/importDefinitions"
            })
        },
        mounted() {
            this.refreshData();
        },
        methods: {
            refreshData() {
                return this.$store.dispatch("jobSchedules/refreshJobSchedules");
            },
            handleAdd() {
                this.focusedJob = {}
            },
            handleDelete(job) {
                this.$store.dispatch("jobSchedules/deleteJobSchedule", job)
                    .then(() => {
                        this.refreshData();
                    })
            },
            handleFocusedChanged(job) {
                this.focusedJob = job;
            },
            handleSave(job) {
                this.$store.dispatch("jobSchedules/saveJobSchedule", job)
                    .then(() => {
                        this.focusedJob = null;
                        this.refreshData();
                    });
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
